import styled from "styled-components";

export const ScrollableX = styled.div`
  overflow-x: auto;
  overflow-y: hidden; 
`;

export const FeatureCard = styled.div`
  display: flex;
  flex-direction: column;
  border: 1px solid ${(props) => props.theme.application.border};
  padding-bottom: 15px;
  margin-bottom: 10px;
`;

export const FeatureCardTitle = styled.div`
  font-weight: 500;
  margin: 5px 10px;
`;

export const FeatureCardRow = styled.div`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-direction: column;
  flex-wrap:wrap;
  @media (min-width: 700px) {
    flex-direction: row;
    align-items: baseline;
  }
`;

export const FeatureCardRowApproval = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  padding-left: 4.5rem;

  @media (min-width: 700px) {
    flex-direction: row;
    align-items: baseline;
  }
`;

interface FeatureCardColumnProps {
  $border?: boolean;
}
export const FeatureCardColumn = styled.div<FeatureCardColumnProps> `
  margin-top: 5px;
  display: flex;
  flex:wrap:wrap;
  flex-direction: column;
  align-items: center;
  width: 90%;
  margin-bottom:10px;

    ${(props) =>
    props.$border &&
    `
    padding:3px;
      border: 1px solid ${props.theme.application.scheme.primary};
    `}


  @media (min-width: 700px) {
    width: 44%;
  }

  div.bold {
    font-weight: 600;
  }
`;

export const FeatureCardSingleColumn = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 90%;
  div.bold {
    font-weight: 600;
  }
`;

